var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"fisical-form-selector"},_vm._l((_vm.list),function(item,idx){return _c('li',{key:idx,staticClass:"formitem",class:{ 'formitem__selected': item.selected },on:{"click":function($event){return _vm.select(idx)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cc67cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/record/cbpf/components/fisical-form-selector/FisicalFormSelector.vue
// module id = null
// module chunks = 